/* eslint-disable */
import * as THREE from 'three'
import r1 from './r1.js'
import c11 from './c11.js'

var s = {
  width: window.innerWidth,
  height: window.innerHeight,
  renderer: {
    antialias: !0,
    alpha: !1,
    bgColor: 16777215,
    shadow: !1,
    pixelRatio: window.devicePixelRatio
  },
  camera: {
    type: "perspective",
    fov: 45,
    near: 1,
    far: 1e3
  },
  wagner: !1,
  orbits: !1,
  verbose: !1
}

var i = function () {
  function r() {
    var e = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {};
    !function (e, t) {
      if (!(e instanceof t))
        throw new TypeError("Cannot call a class as a function")
    }(this, r);
    var t = (0,
      c11.merge)(s, e);
    this.verbose = t.verbose,
      this.verbose,
      this.width = t.width,
      this.height = t.height;
    var n = {
      antialias: t.renderer.antialias,
      alpha: t.renderer.alpha
    };
    if (t.canvas && (n.canvas = t.canvas),
      this.renderer = new THREE.WebGLRenderer(n),
      this.renderer.setSize(this.width, this.height),
      this.renderer.setPixelRatio(t.renderer.pixelRatio),
      t.container && t.container.appendChild(this.renderer.domElement),
      t.renderer.shadow && (this.renderer.shadowMap.enabled = !0,
        this.renderer.shadowMap.type = THREE.PCFSoftShadowMap,
        this.renderer.shadowMap.soft = !0),
      this.scene = new THREE.Scene,
      t.renderer.alpha || (this.scene.background = new THREE.Color(t.renderer.bgColor)),
      this.camera = "perspective" === t.camera.type ? new THREE.PerspectiveCamera(t.camera.fov, this.width / this.height, t.camera.near, t.camera.far) : new THREE.OrthographicCamera(-.5 * this.width, .5 * this.width, .5 * this.height, -.5 * this.height, t.camera.near, t.camera.far),
      this.camera.lookAt(new THREE.Vector3),
      t.orbits) {
      var i = o(391)(THREE);
      this.controls = new i(this.camera)
    }
  }
  return r1(r, [{
    key: "resize",
    value: function (e, t) {
      if (this.verbose,
        this.width = e,
        this.height = t,
        "OrthographicCamera" === this.camera.type) {
        var n = .5 * e
          , i = .5 * t;
        this.camera.left = -n,
          this.camera.right = n,
          this.camera.top = i,
          this.camera.bottom = -i
      } else
        this.camera.aspect = e / t;
      this.camera.updateProjectionMatrix(),
        this.renderer.setSize(e, t)
    }
  }, {
    key: "render",
    value: function () {
      this.renderer.render(this.scene, this.camera)
    }
  }, {
    key: "dispose",
    value: function () {
      this.renderer.dispose(),
        this.renderer = null,
        this.scene = null,
        this.camera = null,
        this.verbose = null,
        this.width = null,
        this.height = null,
        this.controls && (this.controls.dispose(),
          this.controls = null)
    }
  }]),
    r
}();
var t = { default: i }

export default t
